import app from 'flarum/forum/app';
import Page from 'flarum/common/components/Page';
import Link from 'flarum/common/components/Link';
import ResourcePanel from '../components/ResourcePanel';

export default class ResourceDetailPage extends Page {
  id: string | null = null;
  meta: any = null;
  loading = true;

  oninit(vnode: any) {
    super.oninit(vnode);
    this.id = m.route.param('id');
    this.load();
  }

  async load() {
    try {
      const result = await app.request({
        method: 'GET',
        url: app.forum.attribute('apiUrl') + '/resources/' + this.id + '?include=discussion',
      });
      const data = result.data;
      const inc = result.included || [];
      const discussion = inc.find((x: any) => x.type === 'discussions');
      this.meta = {
        title: discussion?.attributes?.title || '(无标题)',
        discussionId: discussion?.id,
        category: data.attributes.category,
        resourceType: data.attributes.resourceType,
      };
    } catch (e) {
      this.meta = { title: '资源不存在或已被删除', discussionId: null, category: '', resourceType: '' };
    }
    this.loading = false;
    m.redraw();
  }

  view() {
    const rh = app.forum.attribute('resourceHub') || {};
    const cat = rh.categories?.find((c: any) => c.key === this.meta?.category);
    const catLabel = cat?.label;
    const typeLabel = cat?.types?.find((t: any) => t.key === this.meta?.resourceType)?.label;

    return (
      <div className="ResourceDetailPage">
        <header className="Hero">
          <div className="container">
            <h1 className="Hero-title">{this.meta?.title || '加载中…'}</h1>
            {(catLabel || typeLabel) && (
              <div className="Hero-subtitle">
                {catLabel && <span className="ResourceDetailBadge">{catLabel}</span>}
                {typeLabel && <span className="ResourceDetailBadge">{typeLabel}</span>}
                {this.meta?.discussionId && (
                  <Link className="ResourceDetailDiscuss" href={app.route('discussion', { id: this.meta.discussionId })}>
                    查看讨论
                  </Link>
                )}
              </div>
            )}
          </div>
        </header>

        <div className="container">
          <Link className="ResourceDetailBack" href={app.route('resources')}>
            ← 返回资源中心
          </Link>
          {!this.loading && <ResourcePanel resourceId={this.id} />}
        </div>
      </div>
    );
  }
}
